<mat-form-field class="actions__select">
  <mat-label>{{ label() }}</mat-label>
  <mat-select
    #statusSelect
    [value]="initialValue()"
    (selectionChange)="enumChanged.emit($event.value)"
    okCustomDropDownArrowDirective
    [disabled]="disabled()">
    @for (item of enumDisplayItems(); track item.value) {
      <mat-option [value]="item.value"> {{ item.displayText }}</mat-option>
    }
  </mat-select>

  @if (initialValue()) {
    <button
      matSuffix
      class="clear-input-field-button"
      type="button"
      (click)="clearInput(); $event.stopPropagation()"
      aria-label="Ryd indhold i feltet">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
    </button>
  }
  <mat-icon matSuffix></mat-icon>
</mat-form-field>
